import React, { Component, ReactNode } from 'react';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';
import ReactTable from 'react-table';

import { Well } from 'react-bootstrap';

import { ILoanCollateralCase } from '../../../interfaces';
import { OptionsStoreClass } from '../../../stores';

import { caseColumns } from './Columns';

// Newest reported first, so the cases that have moved lately head the list
const DEFAULT_SORTED = [{ desc: true, id: 'last_court_records_update_date' }];

interface IProps {
  cases: ILoanCollateralCase[];
  // Shares the title's row, as the loans and compliance tables do
  newButton?: ReactNode;
  onView: (collateralCase: ILoanCollateralCase) => void;
}

interface IInjected extends IProps {
  OptionsStore: OptionsStoreClass;
}

@inject('OptionsStore')
@autoBindMethods
@observer
class CasesTable extends Component<IProps> {
  private get injected () {
    return this.props as IInjected;
  }

  @computed
  private get columns () {
    return caseColumns(this.injected.OptionsStore.loanCollateralCaseResolutionOptions);
  }

  // The whole row is the click target rather than the View button alone: the row is the case, and
  // the button is there to say so.
  private getTrProps (_state: any, rowInfo?: { original: ILoanCollateralCase }) {
    // react-table calls this for the padding rows it draws below the data as well
    if (!rowInfo) { return {}; }

    return { onClick: () => this.props.onView(rowInfo.original) };
  }

  private renderTable () {
    const { cases } = this.props;

    // An account whose cases have not been entered yet keeps the heading, and says so in place of
    // the table rather than showing bare column headers.
    if (!cases.length) {
      return <div className='empty'>There are no primary cases for this account.</div>;
    }

    return (
      <ReactTable
        columns={this.columns}
        data={cases}
        defaultSorted={DEFAULT_SORTED}
        getTrProps={this.getTrProps}
        keyField='id'
        minRows={0}
        pageSize={cases.length}
        resizable={false}
        showPagination={false}
        sortable
      />
    );
  }

  public render () {
    return (
      <Well className='collateral-cases-list well-table'>
        {/* The heading says what these cases are: the firm's own, which the account's loans are secured on */}
        <h3 className='flex-between'>
          Primary Cases
          {this.props.newButton}
        </h3>
        {this.renderTable()}
      </Well>
    );
  }
}

export default CasesTable;
